<div class="row" [ngClass]="{'scrollableNavbar':routeCheckForScrollNavabar}">
  <div class="col px-0 z5" [ngClass]="{'position-fixed  tl0':!routeCheckForScrollNavabar}">
    <div class="wc-topnav">
      <!-- <div class="wc-topNavBg"></div> -->


      <ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
        <span class="successCheck"><i class="fal fa-check"></i> </span>
       <span class="successmsg">{{ successMessage }}</span>
      </ngb-alert>

      <ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
       <span class="errorCheck"><i class="fal fa-times"></i></span>
       <span class="errormsg"> {{ errorMessage }} </span>
      </ngb-alert>
      <div>
        <p class="f-20 font-weight-600 mb-0" style="color: #04363D;">Talent Discovery</p>
      </div>
      <div class="col  d-flex align-items-center justify-content-start position-relative">
        <!-- <a data-testid="auto-app-navbar-a-1" href="https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm?utm_source=gmail" class="wc-btn history-button font-weight-500 " id="chromeE" target="_blank" role="button" [ngbTooltip]="addChromeExtention" placement="right">  <i class="fab fa-chrome mr-3 f-16 font-weight-600"></i> Add Chrome extension</a> -->

        <ng-template #addChromeExtention>
          <p class="font-weight-500 f-14"> Grow your talent pipeline with Webbtree’s Chrome Extension.   </p>
          <p  class="f-12 d-flex " style="color: #777777;"><span ><i class="fas fa-circle mr-3 f-10" style="color: #777777;"></i></span>As you visit profiles on LinkedIn, GitHub, Kaggle, Stack Overflow, and Google Scholar, easily add candidates to talentpool</p>
          <p  class="f-12 d-flex mb-0" style="color: #777777;"> <span><i class="fas fa-circle mr-3 f-10" style="color: #777777;"></i></span> Find their contact information, social profiles, education, experience and skills. </p>


        </ng-template>


      </div>

      <div class="col-md-4 d-flex justify-content-end align-items-center pr-0">
        <!-- <span>
          <a data-testid="auto-app-navbar-a-2" href="https://www.producthunt.com/posts/webbtree?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-webbtree" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=287555&theme=light" alt="Webbtree - Get contact details and perform CRM for recruitment | Product Hunt" style="width: 250px; height: 35px;margin-right: -35px;" width="250" height="35" /></a>
        </span> -->
        <!-- <button data-testid="auto-app-navbar-button-1" class="wc-btn bg-blue py-1 f-12" (click)="route2pricing()">Accounts</button> -->
        <!-- <span class="dropdown ats-dropBtn mx-1 ml-2">
          <button data-testid="auto-app-navbar-button-2" class="ats-btn dropdown-toggle" type="button" id="dropdownMenuButton" appDropdownToggle
            aria-haspopup="true" aria-expanded="false" style="height : 35px;">
            <i class="fas fa-plus"></i> &nbsp;Add New
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a data-testid="auto-app-navbar-a-3" class="dropdown-item" (click)="openCreateCandidate()">Candidate</a>
            <a data-testid="auto-app-navbar-a-4" class="dropdown-item" (click)="openCreateTalentpool()">Talentpool</a>
          </div>
        </span> -->
        <div class="d-flex align-items-center">
          <div class="new-label"  (click)="openFilterModal()">
            <span><i class="fa-solid fa-filter"></i></span>
            <span class="mx-1">Filters</span>
            <span class="count-filter">23</span>
          </div>
          <!-- extension CTA -->
          <div class="extensionCTA bg-color-company mr-3 pointer" *ngIf="!isExtensionInstalled()">
            <div class="extensionIcon" matTooltip="Webbtree Chrome Extension" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <a data-testid="auto-app-navbar-a-5" href="https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm" target="_blank">
                <img src="../../assets/icons/extension-icon.svg" alt="extension-icon">
              </a>
            </div>
          </div>

          <div class="coinsStack mr-3">
            <div class="coinicon"  matTooltip="Balance Coins" [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-coins"></i></div>
            <div>
              <span class="f-14 font-weight-500 ml-1">{{userdata?.balancebasiccontactenrichmentcredits | number:'1.0':'en-US'}}</span>
            </div>
          </div>

          <!-- tour CTA -->
          <div class="tourCTA bg-color-company mr-3 pointer">
            <div class="tourIcon" id="tourDropBtn" appDropdownToggle aria-haspopup="true" aria-expanded="false" matTooltip="Tour" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <i class="fa-solid fa-lightbulb-on text-webbtree-green"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="tourDropBtn">
              <div class="menubox">
                <p class="pointer dropdown-item mb-0" *ngFor="let item of tourItems" (click)="goToTour(item.position)">
                  <i class="fa-solid {{item?.tour_config?.icon}} text-webbtree-green mr-2"></i>
                  <span class="f-14 font-weight-500 ml-1">{{ item.title }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="dropdown help">
            <div class="helpBtn mr-3 dropdown-toggle pointer" id="helpDropBtn"
            appDropdownToggle aria-haspopup="true" aria-expanded="false">
                <span><i class="fa fa-hand-holding-heart mr-1"></i></span>
                <span>Need Help</span>
            </div>
            <div class="dropdown-menu" aria-labelledby="helpDropBtn">
              <div class="menubox">
                  <!-- <p class="f-14 font-weight-500 text-black p-3 mb-0">Help</p>
                  <div class="dropdown-divider"></div> -->
                  <a data-testid="auto-app-navbar-a-6" class="dropdown-item" href="https://webbtree.freshdesk.com/support/solutions/folders/81000298149"  target="_blank"><i class="fa-regular fa-lightbulb-on mr-2"></i>Knowledge base <i class="fa-regular fa-arrow-up-right-from-square text-webbtree-green ml-2"></i></a>
                  <a data-testid="auto-app-navbar-a-7" class="dropdown-item" href="https://webbtree.freshdesk.com/support/tickets/new"  target="_blank"><i class="fa-regular fa-ticket mr-2"></i>Raise a Ticket <i class="fa-regular fa-arrow-up-right-from-square text-webbtree-green ml-2"></i></a>
                  <a data-testid="auto-app-navbar-a-8" class="dropdown-item" (click)="initiatechat()"><i class="fa-regular fa-headset mr-2"></i>Initiate a Live Chat <i class="fa-regular fa-arrow-up-right-from-square text-webbtree-green ml-2"></i></a>
                  <a data-testid="auto-app-navbar-a-9" class="dropdown-item" href="https://webbtree.canny.io/requestfeature" target="_blank"><i class="fa-regular fa-paper-plane mr-2"></i>Request a feature <i class="fa-regular fa-arrow-up-right-from-square text-webbtree-green ml-2"></i></a>
                  <a data-testid="auto-app-navbar-a-10" class="dropdown-item" href="mailto:support@webbtree.com" target="_blank"><i class="fa-regular fa-comment-smile mr-2"></i>Send Feedback to Webbtree <i class="fa-regular fa-arrow-up-right-from-square text-webbtree-green ml-2"></i></a>
              </div>
            </div>
        </div>
        </div>
        <span class="dropdown ats-dropBtn">
          <button data-testid="auto-app-navbar-button-3" class="ats-btn btn-break dropdown-toggle" type="button" id="userDropdownButton"
            appDropdownToggle aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-user-circle sdcol"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-navbar-a-11" class="dropdown-item" routerLink="/settings">Profile Details</a>
            <a data-testid="auto-app-navbar-a-12" class="dropdown-item" routerLink="/settings">Account</a>
            <a data-testid="auto-app-navbar-a-13" class="dropdown-item" routerLinkActive="active" (click)="logout()">Logout</a>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<app-create-candidate [events]="candidateSubject.asObservable()" ></app-create-candidate>


<ng-template #noCreditTalentpool class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-app-navbar-button-4" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modalService.dismissAll()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-6">
              <div class="col text-center mb-4">
                  <img src="../../assets/images/wallet.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-3">
              <div class="col text-center ">
                  <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                  <p class=""  *ngIf="!isteamMember">You have exhausted your limit for creating talent pieplines</p>
                  <p class="" *ngIf="isteamMember">You have exhausted your limit creating talent pieplines, Request more credits from your team admin to keep
                    going</p>
              </div>
          </div>
          <div class="row"  *ngIf="!isteamMember">
              <div class="col-md-10 mx-auto d-flex">
                  <!-- <button data-testid="auto-app-navbar-button-5" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
                  <button data-testid="auto-app-navbar-button-6" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>
